import { FestiveDivider } from "@/components/Festive";

/**
 * RangoliRule — the festive section divider, rendered only while a festival
 * theme with rangoli dividers is active. The artwork is a single image slot:
 * /public/festive/divider.png swaps in the pack's real strip automatically.
 */
export default function RangoliRule() {
  return (
    <div className="mx-auto max-w-xl px-6" data-testid="rangoli-rule">
      <FestiveDivider />
    </div>
  );
}
